// Mutable pixel storage. Buffers are owned by layers; copying is avoided.
// Color is RGBA8 for now; 16/32-bit and other color spaces come in Phase 6.
//
// `version` increments on every mutation. Renderer caches the version they
// last drew and rebuild when it advances.

export type ColorMode = "rgba8";

export class PixelBuffer {
  readonly width: number;
  readonly height: number;
  readonly mode: ColorMode;
  readonly data: Uint8ClampedArray;
  version = 0;

  constructor(width: number, height: number, mode: ColorMode = "rgba8") {
    this.width = width;
    this.height = height;
    this.mode = mode;
    this.data = new Uint8ClampedArray(width * height * 4);
  }

  markDirty(): void {
    this.version++;
  }

  clone(): PixelBuffer {
    const copy = new PixelBuffer(this.width, this.height, this.mode);
    copy.data.set(this.data);
    return copy;
  }
}
